var React = require('react');

function ArrowRightSliderInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#c91c20","key":0}),React.createElement("path",{"fill":"#fff","d":"M13.876 46.664l-5.092-5.093a.774.774 0 0 0-1.092 0l-.462.462a.766.766 0 0 0-.23.546.781.781 0 0 0 .225.552l2.975 2.978H.762a.753.753 0 0 0-.762.759v.654a.782.782 0 0 0 .762.792h9.472l-3 2.994a.764.764 0 0 0 0 1.084l.462.461a.774.774 0 0 0 1.092 0l5.093-5.093a.778.778 0 0 0 0-1.1z","transform":"translate(14.951 -24.563)","key":1})]);
}

ArrowRightSliderInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45"};

module.exports = ArrowRightSliderInline;

ArrowRightSliderInline.default = ArrowRightSliderInline;
